// extracted by mini-css-extract-plugin
export var slider = "TextBold-module--slider--2A3TC";
export var track = "TextBold-module--track--scCjA";
export var slide = "TextBold-module--slide--37Mbq";
export var bulletActive = "TextBold-module--bulletActive--2rwgy";